module.exports = __webpack_public_path__ + "img/recharge_bg.70ff9efe.png";